module.exports = __webpack_public_path__ + "img/ambulance-icon2.5e4622d8.png";